export default "__VITE_ASSET__3b5b3942__"